import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class CollectionAgencyAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'System';
  controllerName = 'IncomeOrganizations';
}

export default new CollectionAgencyAPI();
